import { FixedSizeList as List } from "react-window";
import NoSearchResult from "../../orders/NoSearchResult";
import { ITaxes } from "../../../interfaces/ITaxes";
import { OrderListItem } from "../../orders/OrderList/OrderListItem";
import { ListItemsLoading } from "../../customersDetails/ui/Loading";

interface ITaxesListProps {
    itemList: ITaxes[] | any[];
    columns: any;
    listHeight?: number;
    className?: string;
    itemSize?: number;
    isLoading?: boolean;
    emptyListTitle: string;
    emptyListInfo?: string;
    onItemSelection?: Function;
    isVenueOpen?: boolean;
    maxListLength?: number;
}

export function TaxesList({
    itemList,
    columns,
    className,
    isLoading,
    emptyListTitle,
    emptyListInfo,
    itemSize = 70,
    listHeight = 800,
    onItemSelection,
    isVenueOpen,
    maxListLength = 10
}: ITaxesListProps) {
    const clickItem = (item: any) => {
        if (onItemSelection) onItemSelection({ ...item });
    };
    function Row({ index, style }: any) {
        const item = itemList[index];
        return (
            <div style={style} key={index} data-component-name="TaxesItem">
                <OrderListItem order={item as any} columns={columns}
                    className={className}
                    onClickItem={() => clickItem(itemList[index])}
                    props={{ isVenueOpen }}
                />
            </div>
        );
    }
    if (isLoading) {
        return <ListItemsLoading/>;
    }
    return itemList.length > 0 ? <div >
        <List height={listHeight}
            itemCount={itemList.length}
            itemSize={itemSize}
            width={"100%"}
            style={{
                paddingBottom: "3.5rem",
                overflow: "auto",
            }}
        >
            {Row}
        </List>
    </div> : <NoSearchResult title={emptyListTitle} info={emptyListInfo} />;
}